export const ApiEndpoints = {
  autor: {
    authorList: "api/authors",
    authorCreate: "api/author/store",
    authorEdit: "api/author/edit/",
    authorUpdate: "api/author/update",
    authorDelete: "api/author/delete",
  },

  adminBlogs: {
    blogList: "api/blogs",
    blogCreate: "api/blog/store",
    blogEdit: "api/blog/edit/",
    blogUpdate: "api/blog/update/",
    blogDelete: "api/blog/delete",
  },

  category: {
    categoryList: "api/blog-categories",
    categoryCreate: "api/blog-category/store",
    categoryEdit: "api/blog-category/edit/",
    categoryUpdate: "api/blog-category/update",
    categoryDelete: "api/blog-category/delete",
  },

  projectType: {
    list: "api/project-types",
    create: "api/project-type/store",
    edit: "api/project-type/edit/",
    update: "api/project-type/update",
    delete: "api/project-type/delete",
  },

  project: {
    list: "api/projects",
    create: "api/project/store",
    edit: "api/project/edit/",
    update: "api/project/update/",
    delete: "api/project/delete",
  },

  logo: {
    create: "api/home-client-logo/store",
    edit: "api/home-client-logo/edit",
    delete: "api/home-client-logo/delete",
  },

  testimonial: {
    create: "api/home-testimonial-section/store",
    edit: "api/home-testimonial-section/edit",
    update: "api/home-testimonial-section/update",
    delete: "api/home-testimonial-section/delete",
  },

  stats: {
    create: "api/home-our-stat/store",
    edit: "api/home-our-stat/edit",
    update: "api/home-our-stat/update",
    delete: "api/home-our-stat/delete/",
  },

  weWork: {
    list: "api/how-we-works",
    create: "api/how-we-work/store",
    edit: "how-we-work/edit/",
    update: "api/how-we-work/update/",
    delete: "api/how-we-work/delete",
  },

  home: {
    list: "api/home",
    create: "api/home/store",
    update: "api/home/update/",
  },

  contact: {
    contactList: "api/contact/view",
  },

  seo: {
    seoList: "api/seo",
    seoCreate: "api/seo/store",
    seoEdit: "api/seo/edit/",
    seoUpdate: "api/seo/update",
    seoDelete: "api/seo/delete",
    seoByUrl: 'api/seo-by-url'
  },

  schemaManagement: {
    view: "api/schema-management",
    update: "api/schema-management/update",
  },

  globalSeo: {
    view: "api/global-seo",
    update: "api/global-seo/update",
  },

  sitemap: {
    view: "api/sitemap",
    update: "api/sitemap/update",
  },

  llms: {
    view: "api/llms",
    update: "api/llms/update",
  },

  robots: {
    view: "api/robots",
    update: "api/robots/update",
  },

  faq: {
    faqList: "api/faqs",
    faqCreate: "api/faq/store",
    faqEdit: "api/faq/edit/",
    faqUpdate: "api/faq/update",
    faqDelete: "api/faq/delete",
    faqByUrl: "api/faq-by-url",
  },

  Dashboard: {
    List: "api/leads-count",
    monthlycount: "api/leads-count-filter"
  },

  // Career Module Endpoints
  location: {
    list: "api/locations",
    create: "api/location/store",
    edit: "api/location/edit/",
    update: "api/location/update",
    delete: "api/location/delete",
  },
  
  department: {
    list: "api/departments",
    create: "api/department/store",
    edit: "api/department/edit/",
    update: "api/department/update",
    delete: "api/department/delete",
  },
  
  job: {
    list: "api/jobs",
    create: "api/job/store",
    edit: "api/job/edit/",
    update: "api/job/update",
    delete: "api/job/delete",
  },

  application: {
    applicationList: "api/job/applications",
  },

  dynamic: {
    dynamicList: "api/pages",
    dynamicCreate: "api/page/store",
    dynamicEdit: "api/page/edit/",
    dynamicUpdate: "api/page/update/",
    dynamicDelete: "api/page/delete",
  },

  referral: {
    referralList: "api/referral/view",
  },

  emailManagement: {
    List: "api/dynamic-emails",
    Create: "api/dynamic-email/store",
    Edit: "api/dynamic-email/edit/",
    Update: "api/dynamic-email/update",
    Delete: "api/dynamic-email/delete",
  },

  rbac: {
    myPermissions: "api/rbac/my-permissions",
    userList: "api/rbac/users",
    userCreate: "api/rbac/user/store",
    userEdit: "api/rbac/user/edit/",
    userUpdate: "api/rbac/user/update/",
    userDelete: "api/rbac/user/delete",
    roleList: "api/rbac/roles",
    roleCreate: "api/rbac/role/store",
    roleEdit: "api/rbac/role/edit/",
    roleUpdate: "api/rbac/role/update/",
    roleDelete: "api/rbac/role/delete",
    permissionList: "api/rbac/permissions",
    permissionCreate: "api/rbac/permission/store",
    permissionEdit: "api/rbac/permission/edit/",
    permissionUpdate: "api/rbac/permission/update/",
    permissionDelete: "api/rbac/permission/delete",
  },
};
